module.exports = __webpack_public_path__ + "static/img/old.ff87185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/old.png
// module id = HzkN
// module chunks = 1